import { Pencil, Trash2, Briefcase, Clock3 } from "lucide-react";
import { btnTurq } from "../bits";

export function StaffCard({ s, onEdit, onDelete, onHistory }) {
  const sid = s.id.slice(0, 8);
  return (
    <div data-testid={`staff-card-${sid}`} className="bg-surface rounded-2xl border border-brd shadow-md p-5">
      <div className="flex items-start gap-3 mb-3">
        <div className="w-11 h-11 rounded-xl bg-turq-100 dark:bg-surface2 flex items-center justify-center shrink-0">
          <Briefcase className="w-5 h-5 text-turq-900 dark:text-turq-300" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-head font-bold text-[15px] truncate">{s.name}</div>
          <div className="text-[11px] text-mutext">{s.job_title || "منسوب المدرسة"}</div>
        </div>
        <div className="flex gap-1.5">
          <button data-testid={`staff-edit-${sid}`} onClick={() => onEdit(s)}
            className="w-7 h-7 rounded-lg bg-beige-600 dark:bg-surface2 flex items-center justify-center">
            <Pencil className="w-3 h-3 text-turq-900 dark:text-turq-300" />
          </button>
          <button data-testid={`staff-delete-${sid}`} onClick={() => onDelete(s)}
            className="w-7 h-7 rounded-lg bg-coral-100 dark:bg-surface2 flex items-center justify-center">
            <Trash2 className="w-3 h-3 text-coral-900 dark:text-coral-300" />
          </button>
        </div>
      </div>
      <div className="flex items-center gap-2 mb-3">
        <span className="text-[11px] font-bold bg-coral-100 text-coral-900 dark:bg-surface2 dark:text-coral-300 rounded-full px-3 py-1 flex items-center gap-1">
          <Clock3 className="w-3 h-3" /> {s.total_hours} ساعة
        </span>
        <span className="text-[11px] font-bold bg-beige-600 dark:bg-surface2 rounded-full px-3 py-1">{s.participations} مشاركة</span>
      </div>
      <button data-testid={`staff-log-${sid}`} onClick={() => onHistory(s)}
        className={`${btnTurq} w-full justify-center !py-2 text-xs`}>
        سجل المشاركات والساعات
      </button>
    </div>
  );
}
